import { render, staticRenderFns } from "./StartEmail.vue?vue&type=template&id=2badc7a9&"
import script from "./StartEmail.vue?vue&type=script&lang=js&"
export * from "./StartEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports